import addToTombstone from '../actions/addToTombstone';
import { type default as TombstoneReasonType } from '../store/schema/TombstoneReasonType';
import { getStore } from '../store/Store';
import { orchestrator } from 'satcheljs';

const addToTombstoneOrchestrator = orchestrator(
    addToTombstone,
    async function add({
        instanceKeys,
        folderId,
        tombstoneReasonType,
    }: {
        instanceKeys: string[];
        folderId: string;
        tombstoneReasonType: TombstoneReasonType;
    }) {
        // Create the tombstone map for the folder if it doesn't exist
        const folderTombstoneMap = getStore().folderTombstoneMap;
        if (!(folderId in folderTombstoneMap)) {
            folderTombstoneMap[folderId] = {};
        }

        // Add to tombstone list
        const conversationTombstoneMap = folderTombstoneMap[folderId];
        instanceKeys.forEach(instanceKey => {
            /**
             *  Add tombstone reason if no entry exists for this instanceKey
             */
            const existingTombstonedReasons = conversationTombstoneMap[instanceKey];
            if (!existingTombstonedReasons) {
                conversationTombstoneMap[instanceKey] = [tombstoneReasonType];
                return;
            }

            /**
             * Override the entry if its "RowRemove" type reason
             * If a row is removed and pending delete, no row modified operation should bring it back.
             */
            if (tombstoneReasonType === 1) {
                conversationTombstoneMap[instanceKey] = [1];
                return;
            }

            /**
             * Do not add the entry to the list if
             * there exists a RowRemove reason type entry for this row as it supercedes all other reasons
             */
            if (existingTombstonedReasons.indexOf(1) > -1) {
                return;
            }

            /**
             * Add the tombstone reason to the list if
             * it does not exist in the list
             */
            if (existingTombstonedReasons.indexOf(tombstoneReasonType) === -1) {
                existingTombstonedReasons.push(tombstoneReasonType);
            }
        });
    }
);

export default addToTombstoneOrchestrator;
